/**
 * Main entry point for @zapier/zapier-sdk-core
 *
 * Re-exports all public schemas and types for consumer convenience.
 * Routes and generation utilities are NOT exported (internal use only).
 */

// Schema exports
export {
  AuthenticationSchema,
  AuthenticationItemSchema,
  GetAuthenticationParamSchema,
  type Authentication,
  type AuthenticationItem,
  type GetAuthenticationParam,
  type GetAuthenticationResponse,
} from "./v0/schemas/authentications.js";

export {
  ErrorCodeSchema,
  ErrorSourceSchema,
  ErrorObjectSchema,
  ErrorsResponseSchema,
  type ErrorCode,
  type ErrorSource,
  type ErrorObject,
  type ErrorsResponse,
} from "./v0/schemas/errors.js";

// OpenAPI spec path export
import { fileURLToPath } from "node:url";
import { dirname, resolve } from "node:path";

/**
 * Absolute filesystem path to the generated OpenAPI spec file.
 * Use this to reference the spec from consuming packages.
 *
 * Note: Works in both ESM and CJS environments.
 */
export const openapiSpecPath = (() => {
  // ESM environment
  if (typeof import.meta?.url === "string") {
    return fileURLToPath(new URL("../openapi.yaml", import.meta.url));
  }
  // CJS environment - __dirname is available via tsup's shim
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const currentDir =
    typeof __dirname !== "undefined"
      ? __dirname
      : dirname(require.resolve("@zapier/zapier-sdk-core/package.json"));
  return resolve(currentDir, "../openapi.yaml");
})();
